<template>
    <h2>Bar</h2>
</template>

<script>
    export default ({
        name: "Bar",
    })
</script>

<style>

</style>